import requestPasswordReset from 'src/dataLayer/remoteData/babbelAPI/requestPasswordReset'
import { useRouteParamsContext } from 'src/viewLayer/components/contexts/RouteParamsContext'
import useAsyncData from 'src/viewLayer/components/hooks/useAsyncData'

export default function useResetPasswordRequest({ captchaResponseToken, email }) {
  const { locale } = useRouteParamsContext()
  const { data, inProgress, makeRequest } = useAsyncData(() =>
    requestPasswordReset({ captchaResponseToken, email, locale }),
  )

  return {
    isResetPasswordRequestInProgress: inProgress,
    makeResetPasswordRequest: makeRequest,
    resetPasswordRequest: data || null,
  }
}
